import authRules from '../authRules.js';

const approveJobElements = (user) => {
  const { approveJEs } = user.securityLevels;
  if (approveJEs >= authRules.approveJobElements.approveJEs) {
      return true;
  } else {
      return false;
    }
  }

export default approveJobElements;